/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAppInsights extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAppInsights");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAppInsights.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAppInsights>): ServiceAccountCredentialsForAppInsights {
        let obj = Object.assign(new ServiceAccountCredentialsForAppInsights(), model);
        ServiceAccountCredentialsForAppInsights.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAppInsights>): ServiceAccountCredentialsForAppInsights {
        if (!model) return null;
        return ServiceAccountCredentialsForAppInsights.newInstance(<ServiceAccountCredentialsForAppInsights> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAppInsights) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAppInsights.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAppInsights): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAppInsights.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Application Id. This is a required field.
     */
    application_id: string;

    /**
     * Secret Key. This is a required field.
     */
    secret_key: string;

}
